<template>
  <div class="main-wrapper">

    <div class="main-scroll">
      <Navs :flag='flag'></Navs>
      <home></home>
      <Foots class="foots"></Foots>
    </div>
    <bottom-backtop></bottom-backtop>

  </div>
</template>
<script>
import Navs from '../../common/navs'
import Foots from '../../common/foots'
import home from './ofPublicList'
import BottomBacktop from '../../common/BottomBacktop';

export default {
  components: {
    Navs,
    Foots,
    home,
    BottomBacktop
  },
  name: 'recruitList',
  data() {
    return {flag:false}
  },
  mounted() {
  },
  methods: {}

}
</script>
<style lang="scss" scoped>

</style>
